// extracted by mini-css-extract-plugin
module.exports = {"clientReferralWrapper":"ClientReferral_clientReferralWrapper__3_gdH","title":"ClientReferral_title__3PPRs","itemText":"ClientReferral_itemText__3GpoJ"};